import { render } from "./IndexView.vue?vue&type=template&id=6f5b59ee&scoped=true"
import script from "./IndexView.vue?vue&type=script&lang=js"
export * from "./IndexView.vue?vue&type=script&lang=js"

import "./IndexView.vue?vue&type=style&index=0&id=6f5b59ee&scoped=true&lang=scss"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5b59ee"]])

export default __exports__